// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SESSION_ID } from '../../../../config/session-id';
import { ua } from '../../../../util/user-agent';
import { Captcha } from '../../../components/captcha/captcha.model';

/** @ngInject */
export function Controller(
    $rootScope,
    $scope,
    $state,
    $timeout,
    $window,
    AuthenticationSharedService,
    BarcodeGeneratonService,
    GoogleSharedService,
) {
    $scope.domainName = $state.params.domain;
    
    $scope.showFullPage = false;
    
    $scope.samlImage = window.env.urls.samlAppLogo('google-apps');
    
    
    $scope.errorMessage = ''; 
    $scope.errorCode = $state.params.error_code;
    $scope.codeGoogle = $state.params.code;
    
    if($scope.errorCode){
       if($scope.errorCode == '1'){
           $scope.errorMessage = "The Domain that you want to protect is not the same domain as the email address you selected for authentication.";
       }else if($scope.errorCode == '2'){
           $scope.errorMessage = "You email account is not Google domain admin.";
       }
        
    }else if($scope.domainName && $scope.codeGoogle){
        $scope.showFullPage = true;
    }else{
        const expires = new Date(Date.now() + 60 * 1000).toUTCString();
        document.cookie = `gmarketDomain=${$scope.domainName}; path=/; expires=${expires}`;
            
            
            GoogleSharedService.getGoogleAuthUrl.get({}
            , function(data) {
                
                var redirectUrl = data.requestUrl;
                
                $window.location = redirectUrl;
                
            },
            function(error) {
            }
            );
    
    }
    
    $scope.loggingIn = false;
    
    const captcha = $scope.captcha = new Captcha();
    
    const $ctrl = this;

    $ctrl.loadQrData = () => {
        return BarcodeGeneratonService
            .get({uuid: SESSION_ID}).$promise
            .then((barcode) => {
                $rootScope.passwordMode = $ctrl.passwordMode = barcode.passwordMode;
                $ctrl.mobileLoginUrl = `${window.env.urlSchemaWa}://login?barcode=${barcode.bluetoothcode}`;
                $ctrl.bluetoothCode = barcode.bluetoothcode;
                return barcode.barcodeimage;
            });
    };

 $scope.pulssing = "";
    
    $scope.pulse = function() {            
            $scope.pulssing = "pulseAnimate";
            $("html, body").animate({ scrollTop: $(document).height() }, 2000);

            $timeout(function() {
                $scope.pulssing = "";
            }, 2000);
    };
    
    $scope.login = function () {
        login($scope.username, $scope.password, captcha.response);
    };

    $scope.$on('websocket.LOGIN', (event, data) => {
        login(data.username, data.password);
    });

    function login(username, password, captchaResponse) {
        $scope.loggingIn = true;
        AuthenticationSharedService
            .login({
                username,
                password,
                captchaResponse,
                googleMarketPlaceConfiguration: true,
                domain: $state.params.domain,
                code: $state.params.code,
            })
            .finally(() => {
                $scope.loggingIn = false;
                captcha.reset();
            });
    }
    
    $scope.newLoginButton = ua.isAndroid() || ua.isIOS();
}



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-configuration-login/google-marketplace-configuration-login.controller.js